import { withFormik } from 'formik';
import isEmail from 'isemail';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';

import BasicInput from './fields/BasicInput';

const queryString = require('query-string');

class InnerForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this._toggleConditions = this._toggleConditions.bind(this);
  }

  static propTypes = {
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
    forgotPassword: PropTypes.func,
    isLoggingIn: PropTypes.bool,
    resetForm: PropTypes.func,
    match: PropTypes.object,
    values: PropTypes.object,
    touched: PropTypes.object,
    errors: PropTypes.object,
    setFieldValue: PropTypes.func,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.isLoggingIn && !nextProps.isLoggingIn) {
      this.props.resetForm();
    }
  }

  _toggleConditions() {
    this.props.setFieldValue('conditions', !this.props.values.conditions);
  }

  render() {
    const { handleSubmit, isSubmitting, values, touched, errors, isValid } = this.props;

    return (
      <form className="m-login__form m-form" onSubmit={handleSubmit}>
        <BasicInput {...this.props} name="email" type="text" placeholder="Email" autocomplete="off" disabled />

        <BasicInput
          {...this.props}
          name="password"
          type="password"
          placeholder="Password"
          autocomplete="new-password"
        />

        <BasicInput
          {...this.props}
          name="repeat_password"
          type="password"
          placeholder="Repeat Password"
          className="m-login__form-input--last"
          autocomplete="new-password"
        />

        <div className="row form-group m-form__group m-login__form-sub">
          <div className={'col m--align-left ' + (touched['conditions'] && errors['conditions'] ? 'has-danger' : '')}>
            <label className="m-checkbox m-checkbox--focus">
              <input type="checkbox" name="agree" checked={values['conditions']} onClick={this._toggleConditions} /> I
              Agree the{' '}
              <a
                href="https://www.tomorrowland.com/en/general-terms-conditions-cas"
                target="_blank"
                rel="noopener noreferrer"
                className="m-link m-link--focus"
              >
                terms and conditions
              </a>
              .
              <span />
            </label>
            {touched['conditions'] && errors['conditions'] && (
              <div className="form-control-feedback">
                <Trans>{errors['conditions']}</Trans>
              </div>
            )}
          </div>
        </div>

        <div className="m-login__form-action">
          <button
            id="m_login_signin_submit"
            className="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air"
            disabled={isSubmitting || !isValid}
          >
            Set Password
          </button>
        </div>
      </form>
    );
  }
}

const ResetPasswordForm = withFormik({
  mapPropsToValues: (props) => {
    const data = queryString.parse(window.location.search);
    return {
      email: data.email,
      token: data.token,
      password: '',
      repeat_password: '',
      conditions: false,
    };
  },
  validate: (values, props) => {
    let errors = {};

    if (!values.email || values.email === '') {
      errors.email = 'Required';
    } else if (!isEmail.validate(values.email)) {
      errors.email = 'Invalid email address';
    }

    if (!values.password || values.password === '') {
      errors.password = 'Required';
    } else if (values.password.length < 8) {
      errors.password = 'Password should be at least 8 characters';
    }

    if (!values.repeat_password || values.repeat_password === '') {
      errors.repeat_password = 'Required';
    } else if (values.repeat_password !== values.password) {
      errors.repeat_password = 'Passwords do not match';
    }

    if (!values.conditions) {
      errors.conditions = 'Required';
    }

    return errors;
  },
  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  },
})(InnerForm);

export default ResetPasswordForm;
